export default __webpack_public_path__ + "static/media/logo-white-1x.71ef29f8.webp";